const state = {
    MockCompanyID:null,
    companies:[]
}

export default state
